import {TemplateRef} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {StepConfig} from './step.config';
import {StepComponent} from './step.component';

export class Step {

    //TODO: try to make private
    public initialized = false;

    private _config: StepConfig;

    private completedSubject = new BehaviorSubject<boolean>(false);
    public completed$  = this.completedSubject.asObservable();

    private dataSubject = new BehaviorSubject<any>(null);
    public data$ = this.dataSubject.asObservable();

    private enabledSubject = new BehaviorSubject<boolean>(false);
    public enabled$  = this.enabledSubject.asObservable();

    private optionalSubject = new BehaviorSubject<boolean>(false);
    public optional$  = this.optionalSubject.asObservable();

    private editableSubject = new BehaviorSubject<boolean>(false);
    public editable$  = this.editableSubject.asObservable();

    private hiddenSubject = new BehaviorSubject<boolean>(false);
    public hidden$  = this.hiddenSubject.asObservable();


    public error;

    public template: TemplateRef<StepComponent>;

    public component: StepComponent;

    public index;


    
    public get config(): StepConfig {
        return this._config;
    }
    

    public get editable(): boolean {
        return this.editableSubject.value;
    }

    public set editable(editable: boolean) {
        this.editableSubject.next(editable);
    }

    public get enabled(): boolean {
        return this.enabledSubject.value;
    }

    public set enabled(enabled: boolean) {
        this.enabledSubject.next(enabled);
    }

    public get hidden(): boolean {
        return this.hiddenSubject.value;
    }

    public set hidden(hidden: boolean) {
        this.hiddenSubject.next(hidden);
    }


    public get optional(): boolean {
        return this.optionalSubject.value;
    }

    public set optional(optional: boolean) {
        this.optionalSubject.next(optional);
    }

    public get data(): any {
        return this.dataSubject.value;
    }

    public set data(data: any) {
        this.dataSubject.next(data);
    }

    public get completed(): boolean {
        return this.completedSubject.value;
    }

    public set completed(completed: boolean) {
        this.completedSubject.next(completed);
    }

    constructor(stepConfig: StepConfig) {
        this._config = stepConfig;
        this.enabled = !!stepConfig.enabled;
        this.hidden = !!stepConfig.hidden;
        this.optional = !!stepConfig.optional;
        this.editable = !!stepConfig.editable;


    }
}
